import { useRefreshOnPortalMessage } from './useRefreshOnPortalMessage';

/**
 * Runs `refresh` when the AcombaGO host reports that a send to ACCEO Transphere just finished.
 *
 * The send happens in another AcombaGO window: nothing here unmounts, the browser tab never changes and
 * the panel is never reduced, so without this signal the completeness banner would keep naming invoices
 * as pending right after the agent watched them leave.
 *
 * The host posts it on every completed send, whether or not every document went through — a partial send
 * moves the count too.
 */
export const useRefreshOnTransphereInvoicesSent = (refresh: () => void): void => {
    useRefreshOnPortalMessage('portal:transphere-invoices-sent', refresh);
};
